// Add icon urls to iconCategories from the config
export const getIconCategoriesWithUrl = async (
  config,
  iconsUrl,
  imagesUrl,
  globalIcons = [],
) => {
  // First version that load complete icons set
  if (config.iconSet) {
    try {
      const response = await fetch(`${iconsUrl}/?sets=${config.iconSet}`);
      if (response.ok) {
        const iconCategories = await response.json();
        for (let i = 0; i < iconCategories.length; i += 1) {
          const category = iconCategories[i];
          category.useColorOption = false;

          for (let j = 0; j < category.icons.length; j += 1) {
            const icon = category.icons[j];
            category.icons[j].url =
              `${imagesUrl}${icon.staticImagesFolder}/${icon.id}.${icon.format ?? "png"}`;
            category.icons[j].originalSize = [144, 144]; // for ie11
          }
        }
        return iconCategories;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(
        "Failed to fetch icon sets, fallback to local icons",
        error,
      );
      return [];
    }
  }
  const iconFolder = config.iconFolder || config.id; // iconFolder is used for corporate design icons that have the same icons as an other config
  const cdCategories = (config.iconCategories || []).map((cat) => {
    return {
      ...cat,
      icons: cat.icons.map((icon) => {
        return { ...icon, cd: iconFolder };
      }),
    };
  });

  // Merge CD categories with global categories
  let formatted = [...cdCategories, ...globalIcons].reduce(
    (merged, currentCat, idx, array) => {
      if (
        merged.find((cat) => {
          return cat.id === currentCat.id;
        })
      ) {
        return merged;
      }
      const duplicates = array.filter((cat) => {
        return cat.id === currentCat.id;
      });
      const newCat =
        duplicates.length === 2
          ? {
              icons: [...duplicates[0].icons, ...duplicates[1].icons],
              id: currentCat.id,
              supplement: duplicates[0].supplement || duplicates[1].supplement,
            }
          : duplicates[0];
      return newCat && newCat.icons.length > 0 ? [...merged, newCat] : merged;
    },
    [],
  );
  for (let i = 0; i < formatted.length; i += 1) {
    const category = formatted[i];
    category.useColorOption = false;

    for (let j = 0; j < category.icons.length; j += 1) {
      const icon = category.icons[j];
      icon.url = icon.cd
        ? `${imagesUrl}${icon.cd}/${icon.id}.${icon.format ?? config.iconFormat ?? "png"}`
        : `${imagesUrl}global_icons/${icon.id}.${"png"}`;
      icon.originalSize = [144, 144]; // for ie11
    }
  }

  // Reorder in case a category needs to be at a specific position
  const insertAfterItems = formatted.filter((c) => {
    return c.insertAfter;
  });
  formatted = formatted.filter((c) => {
    return !c.insertAfter;
  });

  insertAfterItems.forEach((cat) => {
    const index = formatted.findIndex((c) => {
      return c.id === cat.insertAfter;
    });
    if (index !== -1) {
      formatted.splice(index + 1, 0, cat);
    } else {
      formatted.push(cat); // fallback if target not found
    }
  });

  return formatted;
};
export default getIconCategoriesWithUrl;
